'use client'
import React from "react";
import { styled } from "@mui/material/styles";
import { Grid2, Typography, Link, Box } from "@mui/material";
import Container from "@mui/material/Container";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../types";
import packageJson from "../../../package.json";

const StyledFooter = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  marginTop: theme.spacing(4),
  width: "100%",
  padding: theme.spacing(3, 0),
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  textDecoration: "underline",
  fontWeight: 500,
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(0.5),
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    color: theme.palette.secondary.light,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    textDecoration: "underline",
    transform: "translateY(-1px)",
  },
}));

const CopyrightSection = styled(Box)(({ theme }) => ({
  textAlign: "center",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

function Footer(): JSX.Element {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <StyledFooter>
      <Container>
        <Box sx={{ py: 2, textAlign: "center" }}>
          <Typography variant="body2" gutterBottom>
            {user && (
              <>
                <FooterLink component={RouterLink} to="/contact">Contact Us</FooterLink>
                {" | "}
              </>
            )}
            <FooterLink component={RouterLink} to="/terms">Terms of Service</FooterLink>
            {" | "}
            <FooterLink component={RouterLink} to="/hostguide">Host Guide</FooterLink>
          </Typography>
          <CopyrightSection>
            <Typography variant="body2">
              © 2025 Copyright:{" "}
              <FooterLink
                href="https://LocalPoker.info"
                target="_blank"
                rel="noopener"
              >
                Local Poker
              </FooterLink>
            </Typography>
          </CopyrightSection>
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Version: v{packageJson.version}
          </Typography>
        </Box>
      </Container>
    </StyledFooter>
  );
}

export default Footer;
